import axios from 'axios';

import { handleAxiosError } from 'core/notifications';

import { getSelectOptions } from '@/exceed';

import getAxiosConfig from './getAxiosConfig';

export default async () => {
  try {
    return getSelectOptions((await axios(getAxiosConfig('get-letters'))).data);
  } catch (error) {
    handleAxiosError(error);
  }
};
